/**
 * 模拟数据
 */
export default ({fetchMock, delay, mock, toSuccess, toError}) => {
  return {
    // 表格带分页
    '/api/fieldcheck/list': (options) => {
      const body = JSON.parse(options.body);
      const currentPage = body.currentPage;
      const idbase = (currentPage - 1) * 10 + 1;
      const paramMap = body.paramMap;
      const deptName = paramMap.deptName;

      if (deptName == 'abcd') {
        return toSuccess(mock({
          'currentPage': currentPage,
          'showCount': body.showCount,
          'totalResult': 0,
          'totalPage': 0,
          dataList: [],
        }), 400)
      }

      return toSuccess(mock({
        'currentPage': currentPage,
        'showCount': body.showCount,
        'totalResult': 100,
        'totalPage': 10,
        [`dataList|${body.showCount}`]: [{
          'id|+1': idbase,
          'deptName': deptName ? deptName : '@name()',      
          'distributionNetwork|1': ['0', '1'],
          'address': '@zip()',
          'type': '@word(3)',  
          'planBeginTime': '@date',
          'planEndTime': '@date',
          'workEmployee|1-3': [{
            'key|+1': 1,
            'title': '@name',
          }],
          'content': '@sentence',
        }],
      }), 400)
    },
    '/api/products/bathDelete': (options) => toSuccess({options}, 400),
    '/api/products/getWorkEmployee': (options) => mock({
      'status': true,
      'data|10': [{
        'key|+1': 1,
        'title': '@name',
      }]
    }),
    '/api/products/save': (options) => toSuccess({options}, 800),
  }
}